import styled from 'styled-components';
import { Button } from '@/ui';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;

export const StyledText = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.DARK_ONYX};
`;

export const StyledBlockText = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  text-transform: uppercase;
  color: ${COLORS.GREY};
`;

export const StyledMessage = styled.div`
  ${pickThemeFontStyles('14', '20', 'SEMI_BOLD')};
  margin-bottom: 1.5rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '24', 'SEMI_BOLD')};
  }
`;

export const StyledLinkBlock = styled.div`
  text-align: center;

  &&& span {
    cursor: pointer;
    ${pickThemeFontStyles('14', '18', 'NORMAL')};
    color: ${COLORS.DARK_ONYX};
    text-decoration: underline;
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    margin-bottom: 1rem;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;
